import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import React from 'react';
import './whatsapp-chat-menu.scss';
import { MenuItem } from '../../../../common/interface';
import { JTBD_SVGS } from '../../../../assets';

interface WhatsappChatMenuProps {
  items: MenuItem[];
  onMenuItemClick: (quickReply: string) => void;
  onSendClick: () => void;
  quickReply: string;
}

export const WhatsappChatMenu: React.FC<WhatsappChatMenuProps> = ({
  items,
  onMenuItemClick,
  onSendClick,
  quickReply,
}) => {
  return (
    <div className="whatsapp-chat-menu">
      <div className="whatsapp-chat-menu-header">
        <span className="whatsapp-chat-menu-header-text tertiary-font-semibold">
          Menu
        </span>
      </div>
      <div className="whatsapp-chat-menu-body">
        {items.map((item) => {
          return (
            <div
              className="menu-item-body"
              onClick={() => {
                onMenuItemClick(item?.title);
              }}
            >
              <div className="menu-item-body-text">
                <span className="menu-item-body-text-title tertiary-font-semibold">
                  {item?.title}
                </span>
                <span className="menu-item-body-text-description tertiary-font-regular">
                  {item?.description}
                </span>
              </div>
              <img
                src={
                  item?.title === quickReply
                    ? JTBD_SVGS.RadioSelected
                    : JTBD_SVGS.RadioUnSelected
                }
                alt=""
              />
            </div>
          );
        })}
      </div>
      <div className="whatsapp-chat-menu-footer">
        <ZoButton
          onClick={() => {
            if (quickReply) {
              onSendClick();
            }
          }}
          label={'Send'}
          className="whatsapp-chat-menu-footer-menu"
        />
      </div>
    </div>
  );
};
